import { render, staticRenderFns } from "./CalendarWrapper.vue?vue&type=template&id=5371f8c6&"
import script from "./CalendarWrapper.ts?vue&type=script&lang=js&"
export * from "./CalendarWrapper.ts?vue&type=script&lang=js&"
import style0 from "./CalendarWrapper.vue?vue&type=style&index=0&id=5371f8c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports